<template>
  <div 
    :style="{ height: '100%' }"
    class="grid-y grid-frame provider-detail typography"
    ref="leaflet-map">
    <div 
      class="cell auto medium-cell-block-container modal-content"
      style="overflow:hidden auto;"
      v-scroll="onScroll">
      <div class="mappy" style="padding:.2rem">
        <l-map
          :zoom="zoom"
          :center="latlng"
          style="height: 420px">
          <l-tile-layer
            :url="url"
            :attribution="attribution"
          />
          <l-marker :lat-lng="latlng"></l-marker>
        </l-map>
    </div>
    <div class="cell shrink modal-bottom-bar small-text-center medium-text-right">
      <div class="grid-x grid-padding-x align-middle">
        <div class="cell auto">
          <h5 class="no-margin bold">{{ title }}</h5>
        </div>
        <div class="cell shrink">
          <a class="btn btn-large no-margin" @click="$modal.hideAll()">Close map</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import { Icon } from 'leaflet'

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
  name: 'LeafletMap',
  components: {
    LMap,
    LTileLayer,
    LMarker
  },
  props: {
    title: {
      type: String,
      required: true
    },
    latlng: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      showMap: false,
      zoom: 12,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    }
  },
  beforeDestroy () {
    let elem = document.querySelector('body')
    if (elem) {
      elem.classList.remove('no-scroll')
    }
  }
}
</script>
